import React, { useState } from 'react'
import styles from '../styles/uplifter-nav-bar.module.scss'
import UplifterSvg from '../assets/svgs/uplifter'
import UplifterMobileIcon from '../assets/uplifter-recreated-nav-icon.png'

export default function UplifterNavBar() {
  const [active, setActive] = useState(false)
  return (
    <nav className={styles.container}>
      <div className={styles.innerDesktop}>
        <a
          href="https://uplifter.ai/"
          target="_blank"
          rel="noreferrer noopener"
        >
          <UplifterSvg className={styles.logo} />
        </a>
        <a
          href="http://uplifter.ai/"
          target="_blank"
          rel="noreferrer noopener"
          className={styles.normalLink}
        >
          Back to Uplifter.ai
        </a>
        <a
          href="http://uplifter.tech/login"
          target="_blank"
          className={`${styles.normalLink}`}
          rel="noreferrer noopener"
        >
          Login
        </a>
      </div>

      <div className={styles.mobileTop}>
        <a
          href="https://uplifter.ai/"
          target="_blank"
          rel="noreferrer noopener"
        >
          <UplifterSvg className={styles.logo} />
        </a>
        <button onClick={() => setActive((a) => !a)}>
          <img
            src={UplifterMobileIcon}
            className={styles.icon}
            alt="uplifter ai"
          />
        </button>
      </div>
      <div
        className={
          active
            ? styles.mobileTransitionContainerActive
            : styles.mobileTransitionContainer
        }
      >
        <div className={styles.innerMobile}>
          <div className={styles.navItem}>
            <a
              href="http://uplifter.ai/"
              target="_blank"
              rel="noreferrer noopener"
              className={styles.normalLink}
            >
              Back to Uplifter.ai
            </a>
          </div>
          <div className={styles.navItem}>
            <a
              href="http://uplifter.tech/"
              target="_blank"
              className={styles.normalLink}
              rel="noreferrer noopener"
            >
              Login
            </a>
          </div>
        </div>
      </div>
    </nav>
  )
}
